// Форма запроса на /coach: гейт отправки общий с заявкой на зал
// (formSubmitGate.ts), плюс лоадер на кнопке — правило проекта, и защита от
// двойного клика, которую лимит частоты сам не ловит.
import { initSubmitGate } from './formSubmitGate'

export const SENDING_LABEL = 'Отправляем…'

export function initConsultForm(root: Document): void {
  const form = root.querySelector<HTMLFormElement>('[data-consult-form]')
  if (!form) return

  const submit = form.querySelector<HTMLButtonElement>('[data-consult-submit]')
  const stopGate = initSubmitGate(form, form.querySelector<HTMLElement>('[data-consult-submit-hint]'))
  // Слушатель после гейта: неполную форму гейт гасит раньше, лоадер её не видит.
  form.addEventListener('submit', (event) => {
    if (!submit || event.defaultPrevented) return

    stopGate()
    submit.disabled = true
    submit.setAttribute('aria-busy', 'true')
    showSending(submit)
  })
}

// Подпись кнопки не затираем, а прячем: у владельца внутри неё обёртка data-ck
// для режима правки, и textContent снёс бы её вместе с текстом.
function showSending(submit: HTMLButtonElement): void {
  const label = submit.querySelector<HTMLElement>('[data-consult-submit-label]')
  if (!label) {
    submit.textContent = SENDING_LABEL
    return
  }

  label.hidden = true
  const sending = submit.ownerDocument.createElement('span')
  sending.dataset.consultSubmitSending = ''
  sending.textContent = SENDING_LABEL
  submit.append(sending)
}
